import { useFormik } from "formik";
import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as yup from "yup";
import Loading from "./Component/Loading";
import { contactUs } from "./Auth/Api";
import Header from "./next-component/Header";
import Footer from "./next-component/footer";

const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    name: "",
    email: "",
    msg: "",
  };
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validationSchema = yup.object({
    name: yup.string().trim().required("Please enter your full name"),

    email: yup
      .string()
      .trim()
      .required("Please enter your email")
      .matches(emailRegExp, "Email is not valid"),
    msg: yup.string().trim(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      addContactUsData(values);
      formik?.resetForm();
    },
  });
  const addContactUsData = async (values) => {
    setIsLoading(true);
    const formData = new FormData();
    formData?.append("fullName", values.name);
    formData?.append("email", values.email);
    formData?.append("message", values.msg);
    try {
      const response = await contactUs(formData);
      if (response?.status) {
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loading />}
      <Header />
      <div className="w-fieldcalc">
        <section className="contactus">
          <Container>
            <div className="cu-heading">
              <h1>
                Get In Touch With <span>FieldCalc</span>
              </h1>
              <p>
                Need assistance? Reach out to us for inquiries or support, we're
                here to help!
              </p>
            </div>
            <Row>
              <Col xs={12}>
                <div className="contactus-box">
                  <Row className="align-items-center">
                    <Col lg={5}>
                      <div className="cub-media">
                        <img
                          src="/contact/contact.svg"
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </Col>
                    <Col lg={7}>
                      <div className="cub-form">
                        <Form onSubmit={formik.handleSubmit}>
                          <Row className="g-3 g-md-4">
                            <Col lg={6}>
                              <Form.Control
                                type="text"
                                size="lg"
                                name="name"
                                placeholder="Full Name"
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  if (/^[A-Za-z\s'-]*$/.test(newValue)) {
                                    formik.handleChange(e);
                                  }
                                }}
                                value={formik?.values?.name}
                              />
                              {formik.errors.name && formik.touched.name ? (
                                <p className="form-error">
                                  {formik.errors.name}
                                </p>
                              ) : null}
                            </Col>
                            <Col lg={6}>
                              <Form.Control
                                type="text"
                                size="lg"
                                name="email"
                                placeholder="Email Address"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                                value={formik?.values?.email}
                              />
                              {formik.errors.email && formik.touched.email ? (
                                <p className="form-error">
                                  {formik.errors.email}
                                </p>
                              ) : null}
                            </Col>
                            <Col lg={12}>
                              <Form.Control
                                as="textarea"
                                name="msg"
                                rows="5"
                                placeholder="Yore Message..."
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                                value={formik?.values?.msg}
                              />
                            </Col>
                            <Col xs={12}>
                              <p className="cub-policy">
                                By continuing, I agree to the{" "}
                                <a href="/privacy-policy" target="_blank">
                                  Privacy Policy
                                </a>
                                &
                                <a href="/terms-of-use" target="_blank">
                                  Terms of Use
                                </a>
                              </p>
                              <Button
                                variant="primary w-100 btn-pill"
                                size="lg"
                                type="submit"
                              >
                                Submit
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
